import { useMemo } from 'react';
import { FeedOutlined as MessageIcon } from '@mui/icons-material';

import { TableRow, IconButton, TableCell, Typography } from '@occc/ui-design-system';

import { DateTimeFormatTZ, formatDateTimeTZ, parseDate } from '../../../../../lib/date';

const MESSAGE_ICON_COLOR = '#888888';

type LocationActivityProps = {
  title: string;
  rawMessage: string;
  onRequestDetailsView: (details: any) => void;
  timestamp: string;
  timezone: string;
};

export const LocationActivity = ({
  title,
  rawMessage,
  onRequestDetailsView,
  timestamp,
  timezone,
}: LocationActivityProps) => {
  const { date, time, timeZone } = useMemo(() => {
    const date = formatDateTimeTZ(parseDate(timestamp), timezone, DateTimeFormatTZ.DateWithSlash);
    const time = formatDateTimeTZ(parseDate(timestamp), timezone, DateTimeFormatTZ.Time24h);
    const timeZone = formatDateTimeTZ(
      parseDate(timestamp),
      timezone,
      DateTimeFormatTZ.ShortTimeZone,
    );

    return { date, time, timeZone };
  }, [timestamp, timezone]);

  return (
    <TableRow>
      <TableCell>
        <Typography component='span' variant='body2'>
          {date}&nbsp;
        </Typography>
        <Typography component='span' variant='body2' fontWeight={600}>
          {time}&nbsp;
        </Typography>
        <Typography component='span' variant='body2'>
          {timeZone}
        </Typography>
      </TableCell>
      <TableCell>{title}</TableCell>
      {/* Member ID will be provided later */}
      <TableCell />
      {/* UMTI will be provided later */}
      <TableCell />
      <TableCell align='center'>
        <IconButton
          sx={{ m: -2 }}
          onClick={() => {
            onRequestDetailsView({ title, rawMessage });
          }}
        >
          <MessageIcon htmlColor={MESSAGE_ICON_COLOR} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
